<!-- 
	This is the tables page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <CardProjectTable2
          :data="tableData"
          :columns="table2Columns"
          @fetchLinks="handleFetchLinks"
        ></CardProjectTable2>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { fetchLinks } from "@/api/index";
// "Authors" table component.
import CardAuthorTable from "./components/CardAuthorTable";

// "Projects" table component.
import CardProjectTable2 from "./components/CardProjectTable2";

// "Authors" table list of columns and their properties.
const table1Columns = [
  {
    title: "归属人",
    dataIndex: "author",
    scopedSlots: { customRender: "author" },
  },
  {
    title: "域名",
    dataIndex: "website",
    scopedSlots: { customRender: "website" },
  },
  {
    title: "分类",
    dataIndex: "func",
    scopedSlots: { customRender: "func" },
  },

  {
    title: "链接",
    dataIndex: "func",
    scopedSlots: { customRender: "func" },
  },
  {
    title: "是否开启轮循",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "像素",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "成效",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "有效期",
    dataIndex: "employed",
    class: "text-muted",
  },
  {
    title: "操作",
    scopedSlots: { customRender: "editBtn" },
    width: 50,
  },
];

// "Authors" table list of rows and their properties.
const table1Data = [
  {
    key: "1",
    author: {
      avatar: "images/face-2.jpg",
      name: "Michael John",
      email: "michael@mail.com",
    },
    website: "John@shopline.com",
    func: {
      job: "Manager",
      department: "Organization",
    },
    status: 1,
    employed: "23/04/18",
  },
  {
    key: "2",
    author: {
      avatar: "images/face-3.jpg",
      name: "Alexa Liras",
      email: "alexa@mail.com",
    },
    website: "John@shopline.com",
    func: {
      job: "Programator",
      department: "Developer",
    },
    status: 0,
    employed: "23/12/20",
  },
  {
    key: "3",
    author: {
      avatar: "images/face-1.jpg",
      name: "Laure Perrier",
      email: "laure@mail.com",
    },
    website: "John@shopline.com",
    func: {
      job: "Executive",
      department: "Projects",
    },
    status: 1,
    employed: "13/04/19",
  },
  {
    key: "4",
    author: {
      avatar: "images/face-4.jpg",
      name: "Miriam Eric",
      email: "miriam@mail.com",
    },
    website: "John@shopline.com",
    func: {
      job: "Marketing",
      department: "Organization",
    },
    status: 1,
    employed: "03/04/21",
  },
  {
    key: "5",
    author: {
      avatar: "images/face-5.jpeg",
      name: "Richard Gran",
      email: "richard@mail.com",
    },
    website: "John@shopline.com",
    func: {
      job: "Manager",
      department: "Organization",
    },
    status: 0,
    employed: "23/03/20",
  },
  {
    key: "6",
    author: {
      avatar: "images/face-6.jpeg",
      name: "John Levi",
      email: "john@mail.com",
    },
    website: "John@shopline.com",
    func: {
      job: "Tester",
      department: "Developer",
    },
    status: 0,
    employed: "14/04/17",
  },
];

// "Projects" table list of columns and their properties.
const table2Columns = [
  {
    title: "类型",
    dataIndex: "type",
    scopedSlots: { customRender: "type" },
    width: 300,
  },

  {
    title: "链接",
    scopedSlots: { customRender: "link" },
    dataIndex: "link",
  },
  {
    title: "",
    scopedSlots: { customRender: "editBtn" },
    width: 50,
  },
];

// "Projects" table list of rows and their properties.
const table2Data = [
  {
    key: "1",
    company: {
      name: "斗篷链接(供恶意用户访问)",
      logo: "images/fake.png",
    },
    status: "working",
    budget: "$14,000",
    completion: 60,
  },
  {
    key: "2",
    company: {
      name: "真实链接(供真实用户访问)",
      logo: "images/true.png",
    },
    status: "working",
    budget: "$3,000",
    completion: 10,
  },
];

export default {
  components: {
    CardAuthorTable,
    CardProjectTable2,
  },
  data() {
    return {
      // Associating "Authors" table data with its corresponding property.
      table1Data: table1Data,

      // Associating "Authors" table columns with its corresponding property.
      table1Columns: table1Columns,

      // Associating "Projects" table data with its corresponding property.
      table2Data: table2Data,

      // Associating "Projects" table columns with its corresponding property.
      table2Columns: table2Columns,
      tableData: [],
    };
  },
  methods: {
    fetchMyLinks() {
      fetchLinks().then((res) => {
        this.tableData = []
        this.tableData.push({
          key: "1",
          type: {
            name: "斗篷链接(供恶意用户访问)",
            logo: "images/fake.png",
          },
          link: res.data.fake[0],
          linkType: "fake",
        });
        res.data.true.forEach((item) => {
          this.tableData.push({
            key: "1",
            type: {
              name: "真实链接(供真实用户访问)",
              logo: "images/true.png",
            },
            link: item,
            linkType: "true",
          });
        });
      });
    },
    handleFetchLinks(){
      this.fetchMyLinks()
    }
  },
  mounted() {
    this.fetchMyLinks()
  },
};
</script>

<style lang="scss">
</style>